.ux-w-shopping-lists-item {
    display: inline-flex;
    flex-direction: column;
    justify-content: space-between;
    min-width: 280px;
    max-width: 280px;
    padding: 20px 30px 30px;
    position: relative;

    .ux-text-tiny {
        text-transform: uppercase;
    }

    &__header {
        padding-bottom: 20px;
        margin-bottom: 15px;
    }

    &__headline {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        margin-bottom: 25px;
    }

    &__label {
        margin-top: 10px;
    }

    &__bottom {
        margin-right: 50px;
    }

    &__button {
        margin-bottom: 10px;

        &--disabled {
            opacity: 0.5;
            pointer-events: none;
        }
    }

    ux-button {
        width: 100%;
    }

    &__cta-container {
        margin-top: auto;
    }

    &__add-to-cart-container {
        &--disabled {
            cursor: not-allowed;
        }
    }
}
